<div class="match-score-popup" [ngClass]="{ 'no-shadow': !showTitle }">
  <div *ngIf="showTitle" class="title">{{ occupation.title }}</div>
  <div *ngIf="occupation.typicalWorkExperienceGroup" class="experience">
    For this occupation you need
    <b>{{ occupation.typicalWorkExperienceGroup }} of experience</b>
  </div>
  <div class="match-score">
    <div
      *ngFor="let item of matchScores"
      class="survey-result"
      [style.color]="item.color"
    >
      <div class="name">{{ item.name }}</div>
      <div class="value">{{ item.matchValue | matchQuality }}</div>
    </div>
  </div>
</div>
